import React, { memo } from 'react';

import { Button } from '@eika/button';

import { useTransactionDetails } from '../../../fetchHooks/useTransactions';
import type { AccountId, TransactionId } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { ErrorCardWrapper } from '../../shared/ErrorCardWrapper';
import TransactionDetailsBody from './TransactionDetailsBody';
import TransactionDetailsSkeleton from './TransactionDetailsSkeleton';

export interface Props {
    transactionId?: TransactionId;
    accountId?: AccountId;
}

const TransactionDetails: React.FC<Props> = memo(({ transactionId, accountId }) => {
    const translated = useTranslation();
    const { data: transactionDetails, isLoading, error, refetch } = useTransactionDetails(accountId, transactionId);

    if (error) {
        return (
            <ErrorCardWrapper
                exception={error}
                defaultError={translated.transactionDetails.errorMessage}
                isModal
                className="transaction-details__error-card"
            >
                <Button onClick={() => refetch()}>{translated.tryAgain}</Button>
            </ErrorCardWrapper>
        );
    }

    if (isLoading || !transactionDetails) {
        return <TransactionDetailsSkeleton />;
    }

    return <TransactionDetailsBody accountId={accountId} transactionDetails={transactionDetails} />;
});

export default TransactionDetails;
